import { render, staticRenderFns } from "./RequestDetail.vue?vue&type=template&id=f78294a0&scoped=true"
import script from "./RequestDetail.vue?vue&type=script&lang=js"
export * from "./RequestDetail.vue?vue&type=script&lang=js"
import style0 from "./RequestDetail.vue?vue&type=style&index=0&id=f78294a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78294a0",
  null
  
)

export default component.exports